import type { MembershipInvitationPayload } from '@livechat/shared';
import { useEffect, useState } from 'react';

import { acceptMembershipInvitation, previewMembershipInvitation } from '../api.js';

interface MembershipInvitationProps {
	onAccepted: (tenantId: string) => void;
	token: string;
}

export function MembershipInvitation({ onAccepted, token }: MembershipInvitationProps) {
	const [invitation, setInvitation] = useState<MembershipInvitationPayload>();
	const [busy, setBusy] = useState(false);
	const [error, setError] = useState<string>();

	useEffect(() => {
		void previewMembershipInvitation(token)
			.then(setInvitation)
			.catch((caught: unknown) =>
				setError(
					caught instanceof Error ? caught.message : 'This invitation is unavailable',
				),
			);
	}, [token]);

	async function accept(): Promise<void> {
		setBusy(true);
		setError(undefined);
		try {
			const accepted = await acceptMembershipInvitation(token);
			onAccepted(accepted.tenantId);
		} catch (caught) {
			setError(caught instanceof Error ? caught.message : 'Could not accept the invitation');
		} finally {
			setBusy(false);
		}
	}

	return (
		<div className="centred-page">
			<section className="auth-card setup-card">
				<p className="eyebrow">Company invitation</p>
				<h2>
					{invitation ? `Join ${invitation.tenantName}` : 'Checking your invitation…'}
				</h2>
				{invitation && (
					<p className="muted">
						Accept the {invitation.role} membership for {invitation.email}. Your
						existing password and other company memberships will not change.
					</p>
				)}
				{error && <div className="alert error">{error}</div>}
				{invitation && (
					<button
						className="primary-button full-button"
						disabled={busy}
						onClick={() => void accept()}
					>
						{busy ? 'Accepting…' : `Join ${invitation.tenantName}`}
					</button>
				)}
			</section>
		</div>
	);
}
